import React from 'react'
import web_development from '../../assets/images/serviceWeProvide/coding.png'
import mobile_develop from '../../assets/images/serviceWeProvide/app-development.png'
import cloud_deveops from '../../assets/images/serviceWeProvide/cloud_deveops.png'
import web_app from '../../assets/images/serviceWeProvide/web_application.png'
import saas_develop from '../../assets/images/serviceWeProvide/saas_develop.png'
import digital from '../../assets/images/serviceWeProvide/digital_marketing.png'
import { Row ,Col, Container} from 'react-bootstrap'
const ServiceItem = ({ icon, title, desc }) => (
  <Col lg={4} md={6} sm={12}>
    <div className="modern-card p-4 h-100 text-center service-hover-card">
      <div className="service-icon-wrapper mb-4">
        <img src={icon} className="service_image" alt={title} style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
      </div>
      <h3 className="service-card-title mb-3" style={{ fontSize: '1.25rem', fontWeight: '700' }}>{title}</h3>
      <p className="service-card-desc text-muted" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
        {desc}
      </p>
    </div>
  </Col>
);

function servicelist() {
  const services = [
    {
      icon: web_development,
      title: "Custom Software Development",
      desc: "Centillion offers top custom software development services for the world’s top SME’s startups and enterprises to build world-class solutions. Leverage our low-risk development approach."
    },
    {
      icon: mobile_develop,
      title: "Mobile App Development",
      desc: "We design and build mobile applications for Android and iOS platforms. Our developers create highly functional, customized mobile applications using pioneer technologies."
    },
    {
      icon: cloud_deveops,
      title: "Cloud & DevOps",
      desc: "Build secure, scalable and world-class enterprise web applications that grow with your business on the cloud with our expert Cloud & DevOps solutions."
    },
    {
      icon: web_app,
      title: "Web Application Development",
      desc: "End-to-end web application development services by building secure, high-performance, intuitive and best-in-class platforms utilizing latest technology."
    },
    {
      icon: saas_develop,
      title: "SaaS Development",
      desc: "Leading SaaS development company offering highly advanced, top-notch successful SaaS-based products to customers worldwide with modern practices."
    },
    {
      icon: digital,
      title: "Digital Marketing",
      desc: "Content helps drive SEO, creates every bit of the user experience, and is the engine that brings your brand personality to life across all digital touchpoints."
    }
  ];

  return (
    <section className="services-section py-100 pt-5 pb-5" style={{ backgroundColor: 'var(--bg-light)' }}>
      <Container>
        <div className="section-header text-center mb-80 ">
          <div className="banner-badge mb-3">Our Expertise</div>
          <h2 className="section-title mb-4" style={{ fontSize: '3rem', fontWeight: '800' }}>
            Services We <span className="gradient-text">Provide</span>
          </h2>
          <p className="text-muted mx-auto" style={{ maxWidth: '700px', fontSize: '1.1rem' }}>
            We deliver cutting-edge technology solutions designed to help your business 
            scale, innovate, and lead in the digital era.
          </p>
        </div>
        
        <Row className="g-4">
          {services.map((service, index) => (
            <ServiceItem key={index} {...service} />
          ))}
        </Row>
      </Container>
    </section>
  );
}


export default servicelist
